import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Skeleton,
    TableContainer,
    TextField

} from '@mui/material';
import ToggleSwitch from '../../../../components/ToggleSwitch/ToggleSwitch';
const projects = [
    {
        dpath: 'https://randomuser.me/api/portraits/women/68.jpg',
        name: 'Vansh Saini',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/men/32.jpg',
        name: 'Devon Lane',
        desk: 'Social Media Strategist',
    },
    {
        dpath: 'https://randomuser.me/api/portraits/women/44.jpg',
        name: 'Leslie Alexander',
        desk: 'Social Media Strategist',
    },
];

const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);

const TimeData = () => {
    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);


    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };


    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Name</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Time hero</TableCell>
                            <TableCell colSpan={2} sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Weekly hours goal</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                        {loading
                            ? [...Array(4)].map((_, i) => (
                                <TableRow key={i}>
                                    {[...Array(5)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))
                            : projects.map((project, index) => (
                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px', fontFamily: 'Manrope' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Avatar variant="pill-rounded" sx={{ width: '46px', height: '46px', backgroundColor: 'unset', backgroundSize: 'cover', objectFit: 'cover' }}>
                                                <img src={project.dpath} className='img-fluid' alt='Drive Icon' sx={{ width: '46px', height: '46px', backgroundSize: 'cover', objectFit: 'cover' }} />
                                            </Avatar>
                                            <Box>
                                                <Typography sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.name}
                                                </Typography>
                                                <Typography fontSize={12} color="text.secondary" sx={{ fontFamily: 'Manrope' }}>
                                                    {project.desk}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <ToggleSwitch />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center', }}>
                                            <TextField type='text' sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    height: '5px',
                                                    width: '70px'
                                                }
                                            }} />
                                            <Typography>Hours</Typography>

                                        </Box>
                                    </TableCell>

                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    )
}

export default TimeData
